import { Directive, ElementRef, input, InputSignal, inject, afterNextRender, Injector } from '@angular/core';
import { InteractivityService } from '../../services/interactivity-service';

@Directive({
  selector: '[tdWbFocusTrackerItem]',
  exportAs: 'tdWbFocusTrackerItem'
})
export class FocusTrackerItemDirective {

  readonly trackById: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'tdWbFocusTrackerItem' });

  private interactivityService: InteractivityService = inject(InteractivityService);
  private injector: Injector = inject(Injector);
  private elementRef: ElementRef = inject(ElementRef);

  focus(): void {
    const target = this.interactivityService.getFirstTabbableElement(this.elementRef.nativeElement);
    if (target !== undefined && target !== null) {
      afterNextRender(() => target.focus(),
        { injector: this.injector }
      );
    }
  }
}

